import axios from "@/axios";

const endpoint = "/business";

const LOAN_DOCUMENT_GROUPS = {
  incomeStatement: {
    category: "INCOME_STATEMENT",
    source: "LOAN_BEACON_FINANCIALS",
  },
  balanceSheet: {
    category: "BALANCE_SHEET",
    source: "LOAN_BEACON_FINANCIALS",
  },
  cashFlow: {
    category: "CASH_FLOW_STATEMENT",
    source: "LOAN_BEACON_FINANCIALS",
  },
  other: {
    category: "OTHER",
    source: "LOAN_BEACON_OTHER",
  },
};

const groupLoanDocuments = (documents = []) => {
  const grouped = {
    incomeStatement: [],
    balanceSheet: [],
    cashFlow: [],
    other: [],
  };

  documents.forEach((document) => {
    if (
      document.category === LOAN_DOCUMENT_GROUPS.incomeStatement.category &&
      document.source === LOAN_DOCUMENT_GROUPS.incomeStatement.source
    ) {
      grouped.incomeStatement.push(document);
      return;
    }

    if (
      document.category === LOAN_DOCUMENT_GROUPS.balanceSheet.category &&
      document.source === LOAN_DOCUMENT_GROUPS.balanceSheet.source
    ) {
      grouped.balanceSheet.push(document);
      return;
    }

    if (
      document.category === LOAN_DOCUMENT_GROUPS.cashFlow.category &&
      document.source === LOAN_DOCUMENT_GROUPS.cashFlow.source
    ) {
      grouped.cashFlow.push(document);
      return;
    }

    if (
      document.category === LOAN_DOCUMENT_GROUPS.other.category &&
      document.source === LOAN_DOCUMENT_GROUPS.other.source
    ) {
      grouped.other.push(document);
    }
  });

  return grouped;
};

const mapLoanDocument = (document) => ({
  id: document.id,
  name: document.name || "",
  type: document.type,
  mimeType: document.mime_type || "",
  sizeBytes: document.size_bytes || 0,
  year: document.reporting_year ? String(document.reporting_year) : "",
  description: document.description || "",
  category: document.category || "",
  source: document.source || "",
  visibility: document.visibility || "",
  createdAt: document.createdAt || document.uploadedAt || null,
  updatedAt: document.updatedAt || null,
});

const LoanBeacon = {
  get: async (businessId) => {
    return axios
      .get(`${endpoint}/${businessId}/loan-beacon`)
      .then(({ loanBeacon }) => ({
        isActive: loanBeacon?.isActive ?? false,
        loanAmount: loanBeacon?.beacon?.loan_amount ?? null,
        loanType: loanBeacon?.beacon?.loan_type ?? null,
        loanUse: loanBeacon?.beacon?.loan_use ?? null,
        personalCreditScore: loanBeacon?.beacon?.personal_credit_score ?? null,
      }))
      .catch(() => ({
        isActive: false,
        loanAmount: null,
        loanType: null,
        loanUse: null,
        personalCreditScore: null,
      }))
  },

  toggle: async (businessId) => {
    return axios
      .patch(`${endpoint}/${businessId}/loan-beacon`)
      .then(({ loanBeacon }) => ({
        isActive: loanBeacon?.isActive ?? false,
        loanAmount: loanBeacon?.beacon?.loan_amount ?? null,
        loanType: loanBeacon?.beacon?.loan_type ?? null,
        loanUse: loanBeacon?.beacon?.loan_use ?? null,
        personalCreditScore: loanBeacon?.beacon?.personal_credit_score ?? null,
      }))
      .catch(() => ({
        isActive: false,
        loanAmount: null,
        loanType: null,
        loanUse: null,
        personalCreditScore: null,
      }));
  },

  update: async (businessId, data) => {
    return axios
      .post(`${endpoint}/${businessId}/loan-beacon`, data)
      .then(({ loanBeacon }) => ({
        isActive: loanBeacon?.isActive ?? false,
        loanAmount: loanBeacon?.beacon?.loan_amount ?? null,
        loanType: loanBeacon?.beacon?.loan_type ?? null,
        loanUse: loanBeacon?.beacon?.loan_use ?? null,
        personalCreditScore: loanBeacon?.beacon?.personal_credit_score ?? null,
      }))
      .catch(() => ({
        isActive: false,
        loanAmount: null,
        loanType: null,
        loanUse: null,
        personalCreditScore: null,
      }));
  },

  loanDocuments: {
    list: async (businessId) => {
      return axios
        .get(`${endpoint}/${businessId}/loan-beacon/documents`)
        .then((documents) => documents.map(mapLoanDocument))
        .catch(() => {
          console.log('[loanBeacon.loanDocuments] Failed');
          return [];
        });
    },

    grouped: async (businessId) => {
      return axios
        .get(`${endpoint}/${businessId}/loan-beacon/documents`)
        .then((documents) => {
          return {
            documents: groupLoanDocuments(documents.map(mapLoanDocument)),
            total: documents.length
          }
        })
        .catch(() => {
          console.log('[loanBeacon.grouped] Failed');
          return {
            documents: {
              incomeStatement: [],
              balanceSheet: [],
              cashFlow: [],
              other: [],
            },
            total: 0
          };
        });
    },
  }
};

export default LoanBeacon;